import { PASSWORD_MESSAGES, passwordSchema } from '@gestao/shared'
import { z } from 'zod'

import * as t from '../../i18n/pt-BR'

/** Campos de confirmação existem só no web; a API recebe os schemas do `@gestao/shared`. */
const confirmSchema = z.string({ error: PASSWORD_MESSAGES.required })

export const ResetPasswordFormSchema = z
  .object({ password: passwordSchema, confirmPassword: confirmSchema })
  .refine((value) => value.password === value.confirmPassword, {
    error: t.auth.confirmMismatch,
    path: ['confirmPassword'],
  })
export type ResetPasswordForm = z.infer<typeof ResetPasswordFormSchema>

export const ChangePasswordFormSchema = z
  .object({
    currentPassword: z
      .string({ error: PASSWORD_MESSAGES.required })
      .min(1, { error: PASSWORD_MESSAGES.required }),
    newPassword: passwordSchema,
    confirmPassword: confirmSchema,
  })
  .refine((value) => value.newPassword !== value.currentPassword, {
    error: t.auth.sameAsCurrent,
    path: ['newPassword'],
  })
  .refine((value) => value.newPassword === value.confirmPassword, {
    error: t.auth.confirmMismatch,
    path: ['confirmPassword'],
  })
export type ChangePasswordForm = z.infer<typeof ChangePasswordFormSchema>
